module.exports = __webpack_public_path__ + "static/media/FS1.df835fd3.png";